import http from "../services/http"
import { ITEMS_PER_PAGE, MAX_RESULT_ITEM, SERVER_DATA_TYPE, FIELD_SOURCE, CLIENT_FUNC, COMPARE, OP, EXP } from "./constants"
import { usePageStore } from "../store/page"

export function validMaxNumber(val, max) {
    var n = Number(val)
    var m = Number(max)

    return n <= m
}

export function validMinNumber(val, min) {
    var n = Number(val)
    var m = Number(min)

    return n >= m
}

export function valid(v) {
    return v !== '' && v !== null && typeof v !== "undefined"
}

export function defined(v) {
    return typeof v !== "undefined"
}

export function openUrl(type, url) {
    if (type == "url") window.open(url);
}

export function shallowCopy(src, dst) {
    for (const key in src) {
        dst[key] = src[key]
    }
}

export function copy(vm, src, dst) {
    if (!src) return;

    var newObj = JSON.parse(JSON.stringify(src));

    for (const key in newObj) {
        vm.$set(dst, key, newObj[key])
    }
}

export function copyObject(src, dst) {
    if (!src) return;

    var newObj = JSON.parse(JSON.stringify(src));
    if (!dst) dst = {}

    for (const key in newObj) {
        dst[key] = newObj[key]
    }
}

export function createDataTablePayload(data, params, childs) {
    const columns = []
    const values = []

    for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
            columns.push(key)
            values.push(data[key])
        }
    }

    return {
        parameters: params,
        columns,
        values,
        childs,
    }
}

export function downloadUrl(fileId) {
    return process.env.VUE_APP_SERVER + "api/files/" + fileId
}

export function filter(name, compare, value, valueType, and, input) {
    return { name, compare, value, valueType, and, input }
}

export function validItemsPerPage(itemsPerPage) {
    if (!itemsPerPage) return ITEMS_PER_PAGE
    if (itemsPerPage > MAX_RESULT_ITEM) return MAX_RESULT_ITEM
    return itemsPerPage
}

export function getTotalPages(totalRows, itemsPerPage) {
    if (!totalRows) {
        return 1
    } else {
        return Math.ceil(
            totalRows / validItemsPerPage(itemsPerPage)
        )
    }
}

function getTypeValue(type, value) {
    if (type == SERVER_DATA_TYPE.DOUBLE || type == SERVER_DATA_TYPE.DECIMAL) {
        if (value) {
            if (typeof value == "number")
                return value
            else
                return Number.parseFloat(value.toString())
        } else {
            return 0.0
        }
    } else if (type == SERVER_DATA_TYPE.INT) {
        if (value) {
            if (typeof value == "number")
                return value
            else
                return Number.parseInt(value.toString())
        } else {
            return 0
        }
    } else if (type == SERVER_DATA_TYPE.BOOLEAN) {
        if (value) {
            if (typeof value == "boolean")
                return value
            else
                return value.toString() == "true"
        } else {
            return false
        }
    } else if (type == SERVER_DATA_TYPE.DATE) {
        if (value) {
            if (value instanceof Date)
                return value
            else
                return new Date(value)
        } else {
            return new Date()
        }
    } else if (value) {
        if (value)
            return value.toString()
        else
            return ""
    } else {
        return null
    }
}

export function getModelValue(nameOrValue, component, model, rowId) {
    if (nameOrValue == null) return null

    var sa = nameOrValue.toString().split(".")

    if (sa.length == 2) {
        if (sa[0] == FIELD_SOURCE.PAGE_MODEL) {
            const pageStore = usePageStore()
            return pageStore.pageModel[sa[1]]
        } else if (sa[0] == FIELD_SOURCE.MODEL || sa[0] == FIELD_SOURCE.MODEL) {
            return model[sa[1]]
        } else if (sa[0] == FIELD_SOURCE.VARIABLE) {
            const pageStore = usePageStore()
            return pageStore.variables[sa[1]]
        }
        else if (sa[0] == FIELD_SOURCE.FUNCTION) {
            return getClientFuncResult(sa[1])
        }
        else {
            return nameOrValue
        }
    } else {
        if (nameOrValue == FIELD_SOURCE.ROW_ID) {
            return rowId
        } else if (nameOrValue == FIELD_SOURCE.ROUTE_PARAM) {
            return component.$route.params.id
        } else {
            return nameOrValue
        }
    }
}

function getClientFuncResult(funcName) {
    if (funcName == CLIENT_FUNC.value_null) {
        return null;
    }
    else if (funcName == CLIENT_FUNC.current_date) {
        return new Date();
    }
    else if (funcName == CLIENT_FUNC.current_day) {
        return (new Date()).getDate();
    }
    else if (funcName == CLIENT_FUNC.current_month) {
        return (new Date()).getMonth();
    }
    else if (funcName == CLIENT_FUNC.current_quater) {
        return (new Date()).getMonth() / 3;
    }
    else if (funcName == CLIENT_FUNC.current_year) {
        return (new Date()).getFullYear();
    }
    else if (funcName == CLIENT_FUNC.current_thai_year) {
        return (new Date()).getFullYear() + 543;
    }
    else if (funcName == CLIENT_FUNC.current_budget_month) {
        const m = (new Date()).getMonth();
        return m > 9 ? m - 9 : m + 3
    }
    else if (funcName == CLIENT_FUNC.current_budget_quater) {
        let m = (new Date()).getMonth();
        m = m > 9 ? m - 9 : m + 3
        return m / 3
    }
    else if (funcName == CLIENT_FUNC.current_budget_year) {
        let d = (new Date())
        let m = m.getMonth()
        return m > 9 ? d.getFullYear() + 1 : d.getFullYear()
    }
    else if (funcName == CLIENT_FUNC.current_thai_budget_year) {
        let d = (new Date())
        let m = m.getMonth()
        return (m > 9 ? d.getFullYear() + 1 : d.getFullYear()) + 543
    }
}

// function getFuncValue(value, valueType, funcName, funcParam) {
//     var p = 0

//     if (valid(value)) {
//         if (valueType == SERVER_DATA_TYPE.DATE) {
//             if (funcParam) {
//                 p = Number.parseInt(funcParam)

//                 if (funcName == CLIENT_FUNC.addDay) {
//                     return value.setDate(value.getDate() + p)
//                 } else if (funcName == CLIENT_FUNC.addHour) {
//                     return value.setHours(value.getHours() + p)
//                 } else if (funcName == CLIENT_FUNC.addMinute) {
//                     return value.setMinutes(value.getMinutes() + p)
//                 } else if (funcName == CLIENT_FUNC.addMonth) {
//                     return value.setMonth(value.getMonth() + p)
//                 } else if (funcName == CLIENT_FUNC.addSecond) {
//                     return value.setSeconds(value.getSeconds() + p)
//                 } else if (funcName == CLIENT_FUNC.addYear) {
//                     return value.setFullYear(value.getFullYear() + p)
//                 }
//             } else {
//                 if (funcName == CLIENT_FUNC.getDay) {
//                     return value.getDate()
//                 } else if (funcName == CLIENT_FUNC.getMonth) {
//                     return value.getMonth()
//                 } else if (funcName == CLIENT_FUNC.getYear) {
//                     return value.getFullYear()
//                 } else if (funcName == CLIENT_FUNC.getHour) {
//                     return value.getHours()
//                 } else if (funcName == CLIENT_FUNC.getMinute) {
//                     return value.getMinutes()
//                 } else if (funcName == CLIENT_FUNC.getSecond) {
//                     return value.getSeconds()
//                 } else if (funcName == CLIENT_FUNC.getDate) {
//                     return new Date(value.getFullYear(), value.getMonth(), value.getDate())
//                 } else if (funcName == CLIENT_FUNC.isLate) {
//                     return value < new Date()
//                 } else if (funcName == CLIENT_FUNC.isNotLate) {
//                     return value > new Date()
//                 }
//             }
//         } else if (valueType == SERVER_DATA_TYPE.BOOLEAN) {
//             if (funcName == CLIENT_FUNC.not) {
//                 return !value
//             }
//         } else {
//             if (funcName == CLIENT_FUNC.isNull) {
//                 return false
//             } else if (funcName == CLIENT_FUNC.isNotNull) {
//                 return true
//             } else if (funcName == CLIENT_FUNC.getPrefix) {
//                 p = Number.parseInt(funcParam)
//                 return value.toString().substr(0, p)
//             } else if (funcName == CLIENT_FUNC.getSuffix) {
//                 p = Number.parseInt(funcParam)
//                 return value.toString().substr(value.length - p, p)
//             } else if (funcName == CLIENT_FUNC.getChar) {
//                 p = Number.parseInt(funcParam)
//                 return value.toString().substr(p, 1)
//             } else if (funcName == CLIENT_FUNC.getLower) {
//                 return value.toString().toLowerCase()
//             } else if (funcName == CLIENT_FUNC.getUpper) {
//                 return value.toString().toUpperCase()
//             }
//         }
//     } else {
//         if (funcName == CLIENT_FUNC.isNull) {
//             return true
//         } else if (funcName == CLIENT_FUNC.isNotNull) {
//             return false
//         }
//     }

//     return value
// }

function compare(v1, cmp, v2) {
    if (cmp == COMPARE.EQUAL) return v1 == v2
    else if (cmp == COMPARE.NOT_EQUAL) return v1 != v2
    else if (cmp == COMPARE.MORE__THAN) return v1 > v2
    else if (cmp == COMPARE.MORE_EQUAL) return v1 >= v2
    else if (cmp == COMPARE.LESS_THAN) return v1 < v2
    else if (cmp == COMPARE.LESS_EQUAL) return v1 <= v2
    else if (cmp == COMPARE.START) return v1.toString().startsWith(v2)
    else if (cmp == COMPARE.END) return v1.toString().endsWith(v2)
    else return v1.toString().search(v2) > -1
}

function operate(v1, op, v2) {
    if (op == OP.AND) {
        return v1 && v2
    } else {
        return v1 || v2
    }
}

export function evaluate(expressions, component, model, rowId) {
    var prevOp = null
    var prevCmp = null
    var prevVal = null
    var prevOpVal = null

    for (let i = 0; i < expressions.length; i++) {
        const e = expressions[i]

        if (e.type == EXP.VALUE) {
            var dv = getModelValue(e.value, component, model, rowId)
            var v = dv || dv == false ? getTypeValue(e.valueType, dv) : null

            // if (e.funcName) {
            //     v = getFuncValue(v, e.valueType, e.funcName, e.funcParam)
            // }

            if (prevVal == null) prevVal = v

            if (prevCmp != null) {
                prevVal = compare(prevVal, prevCmp, v)
                prevCmp = null

                if (prevOp != null) {
                    prevVal = operate(prevVal, prevOp, prevOpVal)
                    prevOp = null
                }
            } else {
                prevVal = v
            }
        } else if (e.type == EXP.COMPARE) {
            prevCmp = e.value
        } else {
            prevOpVal = prevVal
            prevOp = e.value
        }
    }

    return prevVal
}

export function calculate(expressions, component, model, rowId) {
    var prevCal = null
    var prevVal = null

    for (let i = 0; i < expressions.length; i++) {
        const e = expressions[i]

        if (e.type == EXP.VALUE) {
            var dv = getModelValue(e.value, component, model, rowId)
            var v = getTypeValue(e.valueType, dv)

            // if (e.funcName) {
            //     v = getFuncValue(v, e.valueType, e.funcName, e.funcParam)
            // }

            if (prevVal == null) prevVal = v

            if (prevCal != null) {
                if (prevVal != null && v != null) {
                    if (prevCal == "+") {
                        prevVal = prevVal + v
                    } else if (prevCal == "-") {
                        prevVal = prevVal - v
                    } else if (prevCal == "*") {
                        prevVal = prevVal * v
                    } else {
                        prevVal = prevVal / v
                    }
                }

                prevCal = null
            }
        } else if (e.type == EXP.CALCULATE) {
            prevCal = e.value
        }
    }

    return prevVal
}

export function getCombinedSourceAndValue(src, val) {
    let v

    if (
        src == FIELD_SOURCE.PAGE_MODEL ||
        src == FIELD_SOURCE.MODEL ||
        src == FIELD_SOURCE.VARIABLE || src == FIELD_SOURCE.FUNCTION
    ) {
        v = src + "." + val
    }
    else if (src == FIELD_SOURCE.ROW_ID) {
        v = FIELD_SOURCE.ROW_ID
    }
    else if (src == FIELD_SOURCE.ROUTE_PARAM) {
        v = FIELD_SOURCE.ROUTE_PARAM
    }
    else {
        v = val
    }

    return v
}

export function getSourceAndValue(val) {
    let source, value

    if (val) {
        if (val == FIELD_SOURCE.ROW_ID) {
            source = FIELD_SOURCE.ROW_ID
            value = FIELD_SOURCE.ROW_ID
        }
        else if (val == FIELD_SOURCE.ROUTE_PARAM) {
            source = FIELD_SOURCE.ROUTE_PARAM
            value = FIELD_SOURCE.ROUTE_PARAM
        }
        else {
            const sa = val.toString().split(".")

            if (
                sa.length == 2 &&
                (sa[0] == FIELD_SOURCE.PAGE_MODEL ||
                    sa[0] == FIELD_SOURCE.MODEL ||
                    sa[0] == FIELD_SOURCE.VARIABLE ||
                    sa[0] == FIELD_SOURCE.FUNCTION)
            ) {
                source = sa[0]
                value = sa[1]
            } else {
                source = FIELD_SOURCE.VALUE
                value = val
            }
        }
    } else {
        source = FIELD_SOURCE.VALUE
        value = null
    }

    return { source, value }
}

export function getString(text, component, model, rowId) {
    if (text == null || text == "") return ""

    var sa = text.split("|")
    var result = ""

    for (let i = 0; i < sa.length; i++) {
        const e = sa[i]
        result += getModelValue(e, component, model, rowId)
    }

    return result
}

export function createFormData(component, props, model, rowId) {
    if (!props) return {}

    var result = {}

    for (let i = 0; i < props.length; i++) {
        const f = props[i]
        const v = getModelValue(f.value, component, model, rowId)

        if (f.valueType) {
            result[f.name] = getTypeValue(f.valueType, v);
        } else {
            result[f.name] = v;
        }
    }

    return result
}

function getUrlValue(v) {
    if (v == null) return encodeURIComponent("")
    else if (v instanceof Date) return encodeURIComponent(v.toISOString())
    else return encodeURIComponent(v.toString())
}

export function createQueryStrings(component, props, model) {
    if (!props) return {}

    var result = ""

    for (let i = 0; i < props.length; i++) {
        const f = props[i]
        if (i > 0) result += "&"
        result += f.name + "=" + getUrlValue(getModelValue(f.value, component, model))
    }

    return result
}

export function setModel(component, source, output, model) {
    if (output == null || output == "none") return;

    var key;

    if (output == FIELD_SOURCE.PAGE_MODEL) {
        const pageStore = usePageStore()

        for (key in source) {
            pageStore.setPageModelValue(key, source[key])
        }
    } else if (output == FIELD_SOURCE.MODEL) {
        for (key in source) {
            component.$set(model, key, source[key]);
        }
    } else {
        const pageStore = usePageStore()

        for (key in source) {
            pageStore.setVariableValue(key, source[key])
        }
    }
}

export function setModelValue(component, output, targetName, value, model) {
    if (output == null || output == "none" || !targetName) return;

    if (output == FIELD_SOURCE.PAGE_MODEL) {
        const pageStore = usePageStore()
        pageStore.setPageModelValue(targetName, value)
        // component.$set(pageModel, targetName, value);
    } else if (output == FIELD_SOURCE.MODEL) {
        component.$set(model, targetName, value);
    } else {
        const pageStore = usePageStore()
        pageStore.setVariableValue(targetName, value)
        // component.$set(vars, targetName, value);
    }
}

export function createFilter(component, filters, model, rowId) {
    if (!filters) return []

    var outFilters = []

    for (let i = 0; i < filters.length; i++) {
        const f = filters[i]

        var mv = getModelValue(f.value, component, model, rowId)
        if (f.required && !valid(mv)) return null

        var v = f.valueType && valid(mv) ? getTypeValue(f.valueType, mv) : mv

        // if (f.funcName) {
        //     v = getFuncValue(v, f.valueType, f.funcName, f.funcParam)
        // }

        if (v == null && f.input) {
            return null;
        }

        outFilters.push({
            name: f.name,
            compare: f.compare,
            value: v,
            and: f.and
        })
    }

    return outFilters
}

export function createQuery(columns, filters, sortBy, sortMode, requireTotalRows, page, itemsPerPage, keyword) {
    return {
        columns,
        filters,
        sortBy,
        sortMode,
        requireTotalRows,
        page,
        itemsPerPage,
        keyword
    }
}

export async function getDataTableRow(component, table, cols, filters, model, rowId) {
    const compiledFilters = createFilter(
        component,
        filters,
        model,
        rowId
    )

    if (compiledFilters == null) return null

    const q = createQuery(
        cols,
        compiledFilters,
        null,
        null,
        false,
        1,
        1,
        null
    )

    return await http.post(
        "datas/" + table + "/query",
        q
    )
}

export async function getDataTableRowByKey(table, cols, keyName, keyValue) {
    const q = createQuery(
        cols, [{
            name: keyName,
            compare: '=',
            value: keyValue,
        }],
        null,
        null,
        false,
        1,
        1,
        null
    )

    return await http.post(
        "datas/" + table + "/query",
        q
    )
}

export async function getDataTableRows(component, table, cols, filters, model, rowId, keyword, requireTotalRows, page, itemsPerPage, sortBy, sortMode) {
    const compiledFilters = createFilter(
        component,
        filters,
        model,
        rowId
    )

    if (compiledFilters == null) return null

    const q = createQuery(
        cols,
        compiledFilters,
        sortBy,
        sortMode ? sortMode : 'asc',
        requireTotalRows,
        page ? page : 1,
        itemsPerPage ? itemsPerPage : ITEMS_PER_PAGE,
        keyword
    )

    return await http.post(
        "datas/" + table + "/query",
        q
    )
}

export async function insertDataTable(table, data, params, child) {
    const payload = createDataTablePayload(data, params, child)

    return await http.post(
        "datas/" + table,
        payload
    )
}

export async function updateDataTable(table, rowId, data, params, child) {
    const payload = createDataTablePayload(data, params, child)

    return await http.put(
        "datas/" + table + "/" + rowId,
        payload
    )
}

export function modValues2Obj(values) {
    var o = {};

    for (let i = 0; i < values.length; i++) {
        const e = values[i];
        o[e.name] = e.value;
    }

    return o;
}

export function addOrUpdateModel(component, src, target) {
    for (const key in src) {
        if (Object.hasOwnProperty.call(src, key)) {
            const e = src[key];
            component.$set(target, key, e);
        }
    }
}

export async function deleteDataTable(table, rowId) {
    return await http.delete("datas/" + table + "/" + rowId)
}

export function getErrorMessage(msg) {
    if (!msg) {
        return 'Unknow error!'
    } else if (msg.errorMessage) {
        return msg.errorMessage
    } else if (msg.errors) {
        let err = ''

        for (const key in msg.errors) {
            err += msg.errors[key] + ' '
        }

        return err
    }

    return null
}

export function updateClientFilters(filter, filters) {
    let filterIdx = -1;

    for (let i = 0; i < filters.length; i++) {
        const f = filters[i];

        if (f.name == filter.model) {
            filterIdx = i;
            break;
        }
    }

    if (filterIdx > -1) {
        if (filter.value === null) {
            filters.splice(filterIdx, 1);
        } else {
            filters[filterIdx].value = filter.value;
        }
    } else if (filter.value !== null) {
        filters.push({
            name: filter.model,
            compare: "=",
            value: filter.value,
            and: true,
        });
    }
}

export function setComponentModel(component, config, model) {
    if (!config.childs) return

    for (let i = 0; i < config.childs.length; i++) {
        const control = config.childs[i]

        if (!control.hideInForm && !control.readOnly && control.model) {
            var v = null

            if (valid(control.defaultValue)) {
                if (control.defaultValueType) {
                    v = getTypeValue(control.defaultValueType, control.defaultValue)
                } else {
                    if (control.type == "CheckBox") {
                        v = control.defaultValue == "true"
                    } else if (control.type == "NumberBox") {
                        v = Number(control.defaultValue)
                    } else if (control.type == "DatePicker") {
                        if (control.defaultValue == "now") {
                            v = new Date()
                        } else {
                            v = Date.parse(control.defaultValue)
                        }
                    } else {
                        v = control.defaultValue
                    }
                }
            } else {
                if (control.type == "CheckBox") {
                    v = false
                } else if (control.type == "NumberBox") {
                    v = 0
                } else {
                    v = null
                }
            }

            component.$set(model, control.model, v)
        }
    }

    if (config.filters) {
        for (let i = 0; i < config.filters.length; i++) {
            const filter = config.filters[i];

            if (filter.input) {
                component.$set(model, filter.name, filter.value)
            }
        }
    }
}

export function prepareFormData(component, config, model, rowId) {
    const result = {}

    for (let i = 0; i < config.childs.length; i++) {
        const control = config.childs[i];

        if (!control.hideInForm && !control.readOnly && control.model) {
            result[control.model] = model[control.model]
        }
    }

    if (config.filters) {
        for (let i = 0; i < config.filters.length; i++) {
            const filter = config.filters[i];

            if (filter.input) {
                var mv = getModelValue(filter.value, component, model, rowId)
                if (filter.required && !valid(mv)) return null

                var v = filter.valueType && valid(mv) ? getTypeValue(filter.valueType, mv) : mv

                // if (filter.funcName) {
                //     v = getFuncValue(v, filter.valueType, filter.funcName, filter.funcParam)
                // }

                result[filter.name] = v
            }
        }
    }

    if (rowId && config.keyField) result[config.keyField] = rowId

    return result
}

export function getUniqueName(baseName, collection) {
    var n = collection.length + 1;
    var i = 0;

    while (i < collection.length) {
        const c = collection[i];

        if (c.name == baseName + n) {
            n++;
            i = 0;
            continue;
        }

        i++;
    }

    return baseName + n;
}

export function groupBy(values, keyName) {
    const groupBy = []
    let n = -1
    let prevKey = null

    values.forEach((e) => {
        const key = e[keyName]

        if (key != prevKey) {
            prevKey = key
            n++
            groupBy[n] = {
                key,
                items: []
            }
        }

        groupBy[n].items.push(e)
    })

    return groupBy
}